import React from 'react';
import Ellipse from '@splunk/dashboard-visualizations/Ellipse';

export default () => (
    <Ellipse
        options={{ strokeWidth: 5 }}
        encoding={{
            stroke: 'primary.color[3]',
            fill: 'primary[1][-6]',
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        [
                            '#FF0000',
                            '#00FFFF',
                            '#0000FF',
                            '#800080',
                            '#FFFF00',
                            '#FFA500',
                            '#A52A2A',
                            '#008000',
                        ],
                    ],
                    fields: [
                        {
                            name: 'count',
                        },
                        {
                            name: 'color',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
